import { Button } from "@/components/ui/button";
import { RefreshCw, Upload, FileArchive } from "lucide-react";
import { cn } from "@/lib/utils";
import { DOWNLOAD_AGAIN, EXTRACT_START, STARTING_EXTRACTION } from "../constants/const";

type Props = {
    hasFiles: boolean;
    isLoading: boolean;
    onStart: () => void;

    /** Se presente, mostra botão de “Baixar novamente” */
    lastBlob?: Blob | null;
    onDownloadAgain?: () => void;

    /** Customizações opcionais de rótulos (i18n/etc.) */
    labels?: {
        start?: string;
        starting?: string;
        downloadAgain?: string;
    };
};

export function ExtractionFooterActions({
    hasFiles,
    isLoading,
    onStart,
    lastBlob,
    onDownloadAgain,
    labels,
}: Props) {
    const txtStart = labels?.start ?? EXTRACT_START;
    const txtStarting = labels?.starting ?? STARTING_EXTRACTION;
    const txtAgain = labels?.downloadAgain ?? DOWNLOAD_AGAIN;

    return (
        <div className="flex flex-col items-center gap-3">
            <Button
                className={cn("bg-[#613F4F] text-white", "hover:bg-[#613F4F]/90")}
                onClick={onStart}
                disabled={!hasFiles || isLoading}
            >
                {isLoading ? (
                    <>
                        <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
                        {txtStarting}
                    </>
                ) : (
                    <>
                        <Upload className="mr-2 h-4 w-4" />
                        {txtStart}
                    </>
                )}
            </Button>

            {!!lastBlob && !!onDownloadAgain && (
                <Button
                    variant="outline"
                    className={cn("border-[#F6D040] text-[#613F4F]", "hover:bg-[#F6D040]/10")}
                    onClick={onDownloadAgain}
                >
                    <FileArchive className="mr-2 h-4 w-4" />
                    {txtAgain}
                </Button>
            )}
        </div>
    );
}
